import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { NavigationSkeleton } from '@wwe-portal/ui/components/navigation';

import { StoreRevampLayout } from './layout';
import {
  FlagshipSliderSkeleton,
  OfferGridSkeleton,
} from '@wwe-portal/ui/features/offer';
import { RedeemCodeSkeleton } from '@wwe-portal/ui/features/store-revamp';

export const StoreRevampSkeleton = () => {
  return (
    <StoreRevampLayout
      balance={
        <div className="flex items-center justify-center gap-2 md:hidden">
          <Skeleton className="h-[22px] w-[126px]" />
          <Skeleton className="h-[22px] w-[126px]" />
        </div>
      }
      content={<OfferGridSkeleton total={12} />}
      currencySwitch={<Skeleton className="h-[34px] w-full" />}
      eventBar={<Skeleton className="h-[54px] w-full" />}
      exchange={<RedeemCodeSkeleton />}
      flagShip={<FlagshipSliderSkeleton />}
      navigation={<NavigationSkeleton />}
      pageTitle={<Skeleton className="h-6 w-[112px]" />}
    />
  );
};
